export default {
      id: "ic_delete-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.187741c9.svg#ic_delete",
      toString: function () {
        return this.url;
      }
    }